var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',{staticClass:"flex"},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.description)+" ")]),_c('v-list-item-subtitle',{staticClass:"caption"},[_c('AddressFormatter',_vm._b({},'AddressFormatter',_vm.item,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }